import React from 'react';
import { SchematicShell } from './SchematicPrimitives';

export function DormCommandHookSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  strokeColor,
  strokeWidth,
}) {
  const span = view === 'left' || view === 'right' ? depth : width;

  return (
    <SchematicShell
      width={span}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
      drawFrame={false}
    >
      <g
        transform={
          view === 'right' ? `scale(-1, 1) translate(${-span}, 0)` : undefined
        }
      >
        {view === 'left' || view === 'right' ? (
          <SideView
            span={span}
            height={height}
            strokeColor={strokeColor}
            strokeWidth={strokeWidth}
          />
        ) : (
          <FrontView
            span={span}
            height={height}
            strokeColor={strokeColor}
            strokeWidth={strokeWidth}
          />
        )}
      </g>
    </SchematicShell>
  );
}

function FrontView({ span, height, strokeColor, strokeWidth }) {
  const cx = span / 2;
  const hw = span / 2;

  return (
    <ellipse
      cx={cx}
      cy={height / 2}
      rx={hw}
      ry={height / 2}
      fill="none"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      vectorEffect="non-scaling-stroke"
    />
  );
}

function SideView({ span, height, strokeColor, strokeWidth }) {
  const plateThick = span * 0.15;
  const exitY = height * 0.7;
  const lowestY = height * 1.05;
  const tipY = height * 0.4;
  const hookPeakX = span;

  return (
    <g>
      <rect
        x={0}
        y={0}
        width={plateThick}
        height={height}
        rx={plateThick * 0.3}
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d={[
          `M ${plateThick} ${exitY}`,
          `C ${hookPeakX * 0.3} ${exitY + height * 0.1} ${hookPeakX * 0.5} ${lowestY} ${hookPeakX * 0.7} ${lowestY}`,
          `C ${hookPeakX * 0.9} ${lowestY} ${hookPeakX} ${lowestY - height * 0.1} ${hookPeakX} ${lowestY - height * 0.25}`,
          `C ${hookPeakX} ${tipY + height * 0.1} ${hookPeakX * 0.95} ${tipY} ${hookPeakX * 0.9} ${tipY}`,
        ].join(' ')}
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
    </g>
  );
}

DormCommandHookSchematic.supportsSideViews = true;
